/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Genderpreference_Same_Sex8Inputs */

const en__field__enum_genderpreference_same_sex8 = /** @type {(inputs: _Field__Enum_Genderpreference_Same_Sex8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student/Pupil with same sex`)
};

const de__field__enum_genderpreference_same_sex8 = /** @type {(inputs: _Field__Enum_Genderpreference_Same_Sex8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student:in/Schüler:in mit gleichem Geschlecht`)
};

/**
* | output |
* | --- |
* | "Student/Pupil with same sex" |
*
* @param {_Field__Enum_Genderpreference_Same_Sex8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_genderpreference_same_sex8 = /** @type {((inputs?: _Field__Enum_Genderpreference_Same_Sex8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Genderpreference_Same_Sex8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_genderpreference_same_sex8(inputs)
	return de__field__enum_genderpreference_same_sex8(inputs)
});
export { _field__enum_genderpreference_same_sex8 as "_field__enum_genderPreference_SAME_SEX" }